import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import { EditCategoryButton } from "../../styles/diversity-form-styles";

export interface IEditButtonProps {
  setFieldValue: (
    field: string,
    value: unknown,
    shouldValidate: boolean
  ) => void;
  caringResponsibilities: string;
  formLoading: boolean;
}

export const EditButton: FunctionComponent<IEditButtonProps> = ({
  setFieldValue,
  caringResponsibilities,
  formLoading,
}) => (
  <>
    {!formLoading && (
      <ReactTooltip
        place="bottom"
        type="dark"
        effect="solid"
        aria-haspopup="true"
        id="diversity-form-tooltip"
      />
    )}
    <EditCategoryButton
      disabled={formLoading}
      type="button"
      data-tip="Change"
      data-for="diversity-form-tooltip"
      onClick={() => {
        setFieldValue("caringResponsibilities", null, true);
        setFieldValue("caringResponsibilitiesType", null, true);
      }}
    >
      {caringResponsibilities}
      <FontAwesomeIcon icon={faPencilAlt} />
    </EditCategoryButton>
  </>
);

EditButton.propTypes = {
  setFieldValue: PropTypes.func.isRequired,
  caringResponsibilities: PropTypes.string,
  formLoading: PropTypes.bool.isRequired,
};

EditButton.defaultProps = {
  caringResponsibilities: null,
};

export default EditButton;
